module.exports = __webpack_public_path__ + "img/foto-home-oscuro.e8055b26.jpg";